const ITEMS = [
  "Oil on Canvas",
  "Acrylic Works",
  "Commissioned Memories",
  "Tailored Spaces",
  "Visual Poetry",
];

export default function Marquee() {
  const row = (hidden) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="px-8 font-serif text-2xl italic tracking-wide text-cream/90 sm:text-3xl">
            {item}
          </span>
          <span className="text-sm text-gild">✦</span>
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden bg-umber py-7"
    >
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
